import type { AdvisorBlockViewModel } from 'autogen/swagger/all';
import { Container, emblaHOC, Slide, Viewport } from 'components/emblaCarousel';
import { tint } from 'helpers/color';
import { SvgSprite } from 'modules/svgSprite';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, colors, sizes } from 'variables';

const ExpertisesWrapper = styled.div`
    max-width: 100%;

    ${breakpoint.up(sizes.md)} {
        order: 1;
        margin-left: auto;
    }
`;

const ExpertisesSlider = styled.div`
    display: flex;
    justify-content: center;
`;

const StyledSlide = styled(Slide)`
    && {
        flex: 0 0 auto;
        width: 60px;
        height: 60px;

        &:not(:first-child) {
            margin-left: 20px;
        }
    }
`;

const MyExpertisesText = styled.div`
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
`;

const ExpertiseIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: ${tint(0.5, colors.color18)};
`;

const ExpertiseIcon = styled(SvgSprite)`
    width: 35px;
    height: 35px;
    fill: white;
`;

const Expertises = (props: AdvisorBlockViewModel) => {
    const { myExpertisesText, expertises } = props;

    return (
        <ExpertisesWrapper>
            <MyExpertisesText>{myExpertisesText}</MyExpertisesText>
            <ExpertisesSlider>
                <Viewport>
                    <Container>
                        {expertises?.map((expertise, index): JSX.Element => {
                            const { text, sprite } = expertise;
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <StyledSlide key={index}>
                                    <ExpertiseIconWrapper>
                                        <ExpertiseIcon sprite={sprite} />
                                    </ExpertiseIconWrapper>
                                    <div>{text}</div>
                                </StyledSlide>
                            );
                        })}
                    </Container>
                </Viewport>
            </ExpertisesSlider>
        </ExpertisesWrapper>
    );
};

export default emblaHOC({ containScroll: 'trimSnaps', align: 'start' })(Expertises);
